import { uniq } from '../../lib/functional/array.no-deps'
import { findAncestors } from '../units/relations.no-deps'
import type { UnitWithTypeAndParents } from '../units/types.no-deps'
import type { UnitSelectElement } from './types.no-deps'

export const getUnitSelectUnitIds = (
    allUnits: UnitWithTypeAndParents[],
    unitsLookup: Record<number, UnitWithTypeAndParents>,
    element: UnitSelectElement
): number[] => {
    const filteredUnits = allUnits.filter((unit) => element.unitTypes.includes(unit.type))

    const ancestorIds = uniq(
        filteredUnits
            .map((unit: UnitWithTypeAndParents) => findAncestors(unit, unitsLookup))
            .flatMap((a: number[]) => a)
    )

    const filteredIds = filteredUnits.map(({ id }) => id)
    return [...filteredIds, ...ancestorIds]
}
